import * as React from 'react';
import api from '../api/apiClient';
import moment from 'moment';
import 'moment/locale/is';  // Import Icelandic locale
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from "react-router-dom";
import { withRouter } from '../hoc/withRouter';

// Register the locale
moment.locale('is');

class EditEventPage extends React.Component<any, any> {

	constructor(props) {
		super(props);

		this.saveEvent = this.saveEvent.bind(this);
	}

	state = {
		eventId: null,
		seriesId: null,
		name: '',
		description: '',
		location: '',
		date: moment(),
		registrationEnd: moment(),
		registrationStart: moment()
	};

	componentDidMount() {
		this.setState({ seriesId: this.props.match.params.seriesid });

		if (this.props.match.params.eventid) {
			this.loadRace(this.props.match.params.eventid);
		}
	}

	componentDidUpdate(prevProps) {
		// Handle navigation between different events or from edit to add
		if (prevProps.match.params.eventid !== this.props.match.params.eventid ||
			prevProps.match.params.seriesid !== this.props.match.params.seriesid) {

			this.setState({ seriesId: this.props.match.params.seriesid });

			if (this.props.match.params.eventid) {
				this.loadRace(this.props.match.params.eventid);
			} else {
				// Reset to add mode
				this.setState({
					eventId: null,
					name: '',
					description: '',
					location: '',
					date: moment(),
					registrationEnd: moment(),
					registrationStart: moment()
				});
			}
		}
	}

	loadRace(id) {
		api.request('events/' + id).then(data => {
			this.setState({
				eventId: data.id,
				name: data.name,
				location: data.location,
				description: data.description,
				date: moment(data.date),
				registrationStart: moment(data.registrationStart),
				registrationEnd: moment(data.registrationEnd),
			});
		});
	}

	addEvent(event) {
		api.post('events', event).then(data => {
			this.props.history.push('/series/' + this.state.seriesId);
		});
	}

	updateEvent(id, event) {
		api.put('events/' + id, event).then(data => {
			this.props.history.push('/series/' + this.state.seriesId);
		});
	}

	deleteEvent = (eventId) => {
		api.delete('events/' + eventId).then(data => {
			this.props.history.push('/series/' + this.state.seriesId);
		});
	}

	saveEvent(event) {
		if (this.state.eventId) {
			this.updateEvent(this.state.eventId, this.state)
		}
		else {
			this.addEvent(this.state);
		}
	}

	render() {
		// Ensure dates are valid
		const eventDate = moment.isMoment(this.state.date) && this.state.date.isValid() ? this.state.date.toDate() : new Date();

		return (
			<div>
				<h2>Edit event</h2>

				<div>
					<div className="mb-3">
							<label htmlFor="name" className="form-label">Name</label>
							<input type="text" id="name" className="form-control" value={this.state.name} onChange={(event) => this.setState({ name: event.target.value })} />
						</div>
						<div className="mb-3">
							<label htmlFor="location" className="form-label">Location</label>
							<input type="text" id="location" className="form-control" value={this.state.location} onChange={(event) => this.setState({ location: event.target.value })} />
						</div>
						<div className="mb-3">
							<label htmlFor="description" className="form-label">Description</label>
							<input type="text" id="description" className="form-control" value={this.state.description} onChange={(event) => this.setState({ description: event.target.value })} />
						</div>

						<div className="mb-3">
							<label htmlFor="start" className="form-label">Date</label>
							<DatePicker id="start" className="form-control" selected={eventDate} onChange={(date) => this.setState({ date: moment(date) })} locale="is" />
						</div>
				</div>
				<div className="btn-group">
					<Link to={'/series/' + this.props.match.params.seriesid} className="btn btn-warning">Cancel</Link>
					<button onClick={this.saveEvent} className="btn btn-success">Save</button>
					{this.state.eventId && <button onClick={() => this.deleteEvent(this.state.eventId)} className="btn btn-danger">Delete</button>}
				</div>
			</div>
		)
	}

}

export default withRouter(EditEventPage);
